import "./ContactFormStyle.css";

function ContactForm (){
    return(
        <div className="form-container">
            <h1>Envianos un mensaje</h1>
            <form>
                <input placeholder="Name"/>
                <input placeholder="Email"/>
                <input placeholder="Sujeto"/>
                <textarea placeholder="Mensaje" rows="4"/>
                <button>Enviar Mensaje</button>
            </form>
        </div>
    )
}

export default ContactForm;